/*
 Created by CHT 2019/12/4 10:50
 明细表（图表控件）
*/
import BaseChart from "../BaseChart"
import {CHART_CATEGORY__CHART, CHART_TYPE__DETAILED, CHART_TYPE__FILTER_CONTROL} from "../types"
import {DASHBOARD_DATA_SOURCE_EXIST, SUCCESS} from "../../../src/store/types";
import {filterEmpty} from "../../../assets/js/Untis";

class Detailed extends BaseChart {
  constructor() {
    super()
    this.h = 15

    this.minW = 10
    this.minH = 5

    this.chartPropertiesHolder = {
      showFields: [],
      extHeader: [],
      export: 0,        // 是否可导出，0:不可以，1:可以
      showIndex: 0,     // 展示序号
      maxEnable: 0,     // 显示前n行开关，0:关闭，1:打开
      maxCount: '',      // 显示前n行
      freezeEnable: 0,  // 冻结列开关
      freezeColumn: 1,  // 冻结列数
      filter: {
        relation: "and",
        conditionList: [
          /*
            {
              "type":"singleline",
              "method":"eq",
              "value":["No.00001"],
              "fieldId":"SINGLELINEk31hfr93CgKUtL6J"
            }
          */
        ]
      },
      funcFields: [  //函数字段
        // {
        // "dataId":"",  //随机生成，与其余字段不重复
        // "fieldTitle":"",  //名称
        // "formulaExpr": "$fieldId$-$fieldId$", //公式表达式
        // "paramList": [  //公式参数列表
        //   {
        //     "formId": "5e2831fe000d1c0a3b0012f8",
        //     "envVarName": "DESCRIPTION_k6swyegxO66sxlbO"
        //   }
        // ]
        // }
      ],
      dataFormatMap: { //显示格式化 kvContainer
        // "dataId":{
        //   "dataFormatDef":"", //显示格式，预定义：preDef 自定义：customizeDef
        //   "tp":1, //千分符，1：选中，0:未选中
        //   "pt":1,   //百分比，1：选中，0:未选中
        //   "dpSelected":1, //小数点选中状态，1：选中，0:未选中
        //   "dp":1,   //小数点位数，可选值 0 - 6
        //   "dataFormatPattern":"", //显示表达式
        // }
      },
    }

    this.header = []

    this.value = {
      currentPage: 1,
      pageSize: 20,
      totalPage: 1,
      totalCount: 1,
      timestamp: Date.now(),
      dataList: [],
      sort: {}
    }
  }

  get title() {
    return this.chartName || Detailed._title
  }

  set title(content) {
    this.chartName = content
  }

}

Detailed._title = '明细表'
Detailed.type = CHART_TYPE__DETAILED

Detailed.prototype.chartCategory = CHART_CATEGORY__CHART
Detailed.prototype.chartType = Detailed.type
Detailed.prototype.resetDataSource = function (opts) {
  const {
    dataSourceName,
    dataSourceType,
    dataSourceId
  } = opts

  this.dataSourceName = dataSourceName
  this.dataSourceId = dataSourceId
  this.dataSourceType = dataSourceType

  this.chartPropertiesHolder = {
    showFields: [],
    extHeader: [],
    export: 0,        // 是否可导出，0:不可以，1:可以
    showIndex: 1,     // 展示序号
    maxEnable: 1,     // 显示前n行开关，0:关闭，1:打开
    maxCount: '',      // 显示前n行
    freezeEnable: 0,  // 冻结列开关
    freezeColumn: 1,  // 冻结列数
    filter: {
      relation: "and",
      conditionList: [
        /*
          {
            "type":"singleline",
            "method":"eq",
            "value":["No.00001"],
            "fieldId":"SINGLELINEk31hfr93CgKUtL6J"
          }
        */
      ]
    }
  }

  this.value = {
    currentPage: 1,
    pageSize: 20,
    totalPage: 1,
    totalCount: 1,
    timestamp: Date.now(),
    dataList: [],
    sort: {}
  }

  // 清除相关筛选器数据
  this.parent.children.forEach(chart => {
    if (chart.chartType === CHART_TYPE__FILTER_CONTROL) {
      if (Object.keys(chart.chartPropertiesHolder.chartFilterMap).includes(this.chartId)) {
        delete chart.chartPropertiesHolder.chartFilterMap[this.chartId]
      }
    }
  })
}
Detailed.prototype.getValue = function (opts = {}, filter) {

  if (this.hidden) {
    // 图表不可见，不用请求数据
    return
  }

  this.isLoad = false

  const chart = Object.assign(this.getBase(), opts)

  if (!filter) {
    const chartCondition = []
    this.parent.children
      .filter(chart => chart.chartType === CHART_TYPE__FILTER_CONTROL)
      .forEach(filterControl => {
        const holder = filterControl.chartPropertiesHolder
        const filterConf = holder.chartFilterMap[this.chartId]

        if (filterConf && filterControl.value.method) {
          chartCondition.push({
            type: "",
            method: filterControl.value.method,
            value: filterControl.value.value,
            fieldId: filterConf.dataId,
            fixedValue: filterControl.value.fixedValue,
            extValue: filterControl.value.extValue
          })
        }
      })

    filter = {
      relation: "and",
      conditionList: chartCondition,
    }
  }

  if (((this.parent.styles && this.parent.styles.filterEmptyLoadData && this.parent.styles.filterEmptyLoadData === 'NO') ||
    (this.showPropertiesHolder.filterEmptyLoadData && this.showPropertiesHolder.filterEmptyLoadData === 'NO')) && filterEmpty(filter)) {
    this.value.currentPage = 1
    this.value.totalPage = 0
    this.value.totalCount = 0
    this.header = []
    this.value.dataList.splice(0, this.value.dataList.length)
    this.isLoad = true
    return
  }
  this.parent.chartDataPreviewFun({
    chartId: this.chartId,
    currentPage: this.value.currentPage,
    pageSize: this.value.pageSize,
    sort: this.value.sort,
    filter,
    chart
  }).then(({status, resultObject, info}) => {

    if (status === SUCCESS) {
      const {structHeader, dataHolder} = resultObject
      structHeader.forEach(item => item.show = true)
      this.header.splice(0, this.header.length, ...structHeader)
      this.value.currentPage = dataHolder.currentPage
      this.value.totalPage = dataHolder.totalPage
      this.value.totalCount = dataHolder.totalCount
      this.value.timestamp = dataHolder.timestamp
      this.value.dataList.splice(0,
        this.value.dataList.length,
        ...dataHolder.dataList
      )
    } else if (status === DASHBOARD_DATA_SOURCE_EXIST) {
      this.errorPrompt = '控件已删除'
    }
    console.log({status, resultObject, info}, this.value);

  }).catch(err => {
    console.error(err)
  }).finally(() => {
    this.isLoad = true
  })
}
Detailed.prototype.resetValue = function () {
  this.header = []

  this.value = {
    currentPage: 1,
    pageSize: 20,
    totalPage: 1,
    totalCount: 1,
    timestamp: Date.now(),
    dataList: [],
    sort: {}
  }
}

export default Detailed
